var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block",
      shapeRendering: "auto"
    },
    width: "80px",
    height: "80px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(67,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9925558312655087s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9925558312655087s"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.05275243610457,57.90029392474406)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.69230769230769)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.9230769230769231
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.9098428453267163s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.9098428453267163s"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.65710069442965,63.99072572019216)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(55.38461538461538)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.8461538461538461
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8271298593879239s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8271298593879239s"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.04912356434049,66.87605085966692)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(83.0769230769231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.7692307692307693
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7444168734491315s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7444168734491315s"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.9717169202769,65.89527612565205)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(110.76923076923076)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.6923076923076923
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6617038875103392s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6617038875103392s"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.275317281091276,61.27308519009352)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(138.46153846153848)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.6153846153846154
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5789909015715468s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5789909015715468s"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.493989103757116,54.068366292888484)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(166.1538461538462)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.5384615384615384
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.49627791563275436s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.49627791563275436s"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.493989103757116,45.93163370711152)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(193.84615384615384)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.46153846153846156
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.41356492969396197s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.41356492969396197s"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.275317281091276,38.72691480990649)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(221.53846153846152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.38461538461538464
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.3308519437551696s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.3308519437551696s"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.97171692027689,34.104723874347954)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(249.23076923076923)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.3076923076923077
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.24813895781637718s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.24813895781637718s"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.0491235643405,33.12394914033308)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(276.92307692307696)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.23076923076923078
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.1654259718775848s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.1654259718775848s"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.65710069442963,36.009274279807826)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(304.6153846153846)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.15384615384615385
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.0827129859387924s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.0827129859387924s"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.05275243610457,42.09970607525594)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(332.3076923076924)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#0184cb",
    fillOpacity: 0.07692307692307693
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "0.6900000000000001 0.6900000000000001;1 1",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.075268817204301s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.04848a2afcc3560faf6549557a3db902.svg";
export { ForwardRef as ReactComponent };